import PrinterConfig from '../types/printer_config'

export default function getPrinterConfig() {
    const printerConfig = localStorage.getItem('printer_config') || 'null'
    return JSON.parse(printerConfig) as PrinterConfig | null
}
